var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "form-check d-flex flex-column flex-md-row mt-3 mb-1 align-items-center"
    },
    [
      _c("span", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.current_value,
              expression: "current_value"
            }
          ],
          staticClass: "form-check-input",
          attrs: {
            id: _vm.id,
            name: _vm.name,
            disabled: _vm.inputDiasables,
            value: "true",
            type: "checkbox"
          },
          domProps: {
            checked: Array.isArray(_vm.current_value)
              ? _vm._i(_vm.current_value, "true") > -1
              : _vm.current_value
          },
          on: {
            change: function($event) {
              var $$a = _vm.current_value,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "true",
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.current_value = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.current_value = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.current_value = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-check-label", attrs: { for: _vm.id } },
          [_vm._v("\n            " + _vm._s(_vm.textPrivacy) + "\n        ")]
        )
      ]),
      _vm._v(" "),
      _vm.modal
        ? _c("span", [
            _vm._v("["),
            _c(
              "span",
              {
                staticClass: "click-modal",
                on: { click: _vm.openPrivacyModal }
              },
              [_vm._v("Leggi")]
            ),
            _vm._v("]")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: _vm.name,
          attrs: { name: _vm.name, extraClass: "privacyModal" }
        },
        [
          _c("template", { slot: "header" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.langPrivacy[_vm.modal].title) }
            })
          ]),
          _vm._v(" "),
          _c("template", { slot: "body" }, [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(_vm.langPrivacy[_vm.modal].content)
              }
            })
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-network btn-md",
                on: { click: _vm.closePrivacyModal }
              },
              [_vm._v("Ho letto")]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }